export default "__VITE_ASSET__CBTB0JRQ__"